import React, { useCallback, useState } from "react";
import { StyleContext } from "./StyleContext";

export const StyleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [backgroundColor, setBackgroundColor] = useState("#000000"); // Default to black
    const [textColor, setTextColor] = useState("#ffffff"); // Default to white
    const [buttonTextColor, setButtonTextColor] = useState("#ffffff"); // Default to white
    const [primaryColor, setPrimaryColor] = useState("#00E8AE"); // Default to primary

    const setBrandingColors = useCallback((bgColor: string, txtColor: string, primaryColor: string, btnTextColor: string) => {
        setBackgroundColor(bgColor);
        setTextColor(txtColor);
        setButtonTextColor(btnTextColor);
        setPrimaryColor(primaryColor);
    }, []);

    return (
        <StyleContext.Provider value={{ backgroundColor, setBrandingColors }}>
            <div
                style={{
                    "--text-color": textColor,
                    "--button-text-color": buttonTextColor,
                    "--color-primary-400": primaryColor,
                    backgroundColor,
                    transition: "background-color 1.5s ease",
                    overflow: "hidden",
                    height: "100vh",
                    width: "100vw",
                    position: "fixed",
                } as React.CSSProperties}
            >
                {children}
            </div>
        </StyleContext.Provider>
    );
};